module.exports = __webpack_public_path__ + "static/mairy-bold-webfont-0f732744872495f6678a5f930f38875c.woff";